import { useQuery } from '@tanstack/react-query';
import useAuth from 'src/hooks/useAuth';
import { bindCanvasDocumentViewer, canvasDocumentTargetKey, canvasViewerKey, fetchCanvasDocumentTarget } from '../api';

/** Resolve whether a document id is canvas markdown, and where that canvas opens. */
export function useCanvasDocumentTarget(documentId: string | undefined) {
  const { user } = useAuth();
  const viewer = canvasViewerKey(user);
  bindCanvasDocumentViewer(viewer);
  return useQuery({
    queryKey: documentId ? canvasDocumentTargetKey(documentId) : ['canvas-document-target', viewer, 'none'],
    queryFn: () => fetchCanvasDocumentTarget(documentId as string),
    enabled: Boolean(documentId),
    // A live canvas head becomes a historical version on the next save, so this
    // must be refetched rather than kept for the session.
    staleTime: 0
  });
}
